// AccountSection.jsx

import React, {useState} from "react";
import MenuCard from "./MenuCard";
import { apiRequest } from '../../../../fetchSetup';
import { useNavigate } from "react-router-dom";
import {
 Typography,  Button,
  Dialog, DialogTitle, DialogContent, DialogActions,
  Divider, 
} from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";

const AccountSection = ({
  setPasswordOpen,
  setLogoutOpen,
}) => {
   const [logoutDialogOpen, setLogoutDialogOpen] = useState(false);
  
  const navigate=useNavigate()

  const handleLogout = async () => {
      try {
        const token = sessionStorage.getItem("token");
        const userId = sessionStorage.getItem("userId");
        const logoutapi = process.env.REACT_APP_LOGOUT_API;
        await apiRequest(`${logoutapi}/${userId}`, {
          method: "POST",
          headers: { Authorization: `Bearer ${token}` },
        });
      } catch (error) {
        console.error("Logout failed:", error);
      } finally {
        sessionStorage.clear();
        navigate("/Login");
      }
    };
  return (
    <>
      <MenuCard
        title="Logout"
        subtitle="Sign out from your account"
        icon={<LogoutRoundedIcon />}
        danger
        onClick={() => setLogoutDialogOpen(true)}
      />
      <Dialog
        open={logoutDialogOpen}
        onClose={() => setLogoutDialogOpen(false)}
        maxWidth="xs"
        fullWidth
        PaperProps={{ sx: { borderRadius: 2 } }}
      >
        <DialogTitle sx={{ color: "#006D77", fontWeight: 600, pb: 1 }}>
          Confirm Logout
        </DialogTitle>
        <Divider />
        <DialogContent sx={{ pt: 2.5 }}>
          <Typography variant="body1" sx={{ color: "#444" }}>
            Are you sure you want to logout?
          </Typography>
        </DialogContent>
        <DialogActions sx={{ p: 2.5, pt: 1.5, gap: 1 }}>
          <Button
            onClick={() => setLogoutDialogOpen(false)}
            variant="outlined"
            sx={{
              textTransform: "none",
              borderColor: "#ccc",
              color: "#666",
              "&:hover": { borderColor: "#999", backgroundColor: "#f5f5f5" },
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleLogout}
            variant="contained"
            sx={{
              textTransform: "none",
              backgroundColor: "#d32f2f",
              "&:hover": { backgroundColor: "#b71c1c" },
            }}
          >
            Yes, Logout
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default AccountSection;